import { render, staticRenderFns } from "./appointments.vue?vue&type=template&id=3d88abb4&scoped=true&"
import script from "./appointments.vue?vue&type=script&lang=js&"
export * from "./appointments.vue?vue&type=script&lang=js&"
import style0 from "./appointments.vue?vue&type=style&index=0&id=3d88abb4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d88abb4",
  null
  
)

component.options.__file = "appointments.vue"
export default component.exports